

































/**
 * 常规展示歌单的 item
 */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ABAction } from '@/stores/audioBar';

@Component
export default class PlayListCard extends Vue {
  @Prop({
    type: Number,
    required: true,
  }) public id!: number;

  @Prop({
    type: String,
    required: true,
  }) public src!: string;

  @Prop({
    type: Number,
    required: true,
  }) public count!: number;

  @Prop({
    type: String,
    required: true,
  }) public playLink!: string;

  @Prop({
    type: String,
    required: true,
  }) public title!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) public showName!: boolean;

  @Prop({
    type: String,
    default: '',
  }) public name!: string;

  get CountStr() {
    const count = Math.floor(this.count);
    return count >= 10000 ? `${Math.floor(count / 10000)}万` : count;
  }

  /**
   * 点击播放歌单
   */
  public handleClickPlay() {
    // 拉取歌单并播放第一首
    this.$store.dispatch(ABAction('startPlayNewList'), {id: this.id});
  }
}
